import styled from 'styled-components'

export const CompanyName = styled.div`
  line-height: 1.2em;
  font-size: 18px;
  font-weight: bold;
  margin-top: 5px;
  padding: 15px 0;
`

export const AddMailConfirmationMessage = styled.div`
  line-height: 19px;
  font-size: 14px;
`

export const BackLink = styled.a`
  line-height: 51px;
  font-weight: 600;
  text-decoration: underline;
  margin-top: 16px;
`
